// ────────────────
// Types & Helpers
// ────────────────
export type QueryParamValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | Array<string | number | boolean>
export type QueryParams = Record<string, QueryParamValue>

export interface SelectedQueryPath {
  toolId: string
  huntQueryId: string
  pivotIds: string[]
}

export interface QueryClickEvent {
  type: 'query' | 'pivot'
  toolId: string
  queryId: string
  pivotPath?: string[]
  pivotKey: string
}

/** Build a comma-separated selectedQueryId string */
export function buildSelectedQueryId(
  huntQueryId?: string,
  pivotIds: string[] = [],
): string {
  if (!huntQueryId) {
    console.warn('[buildSelectedQueryId] Missing huntQueryId', { huntQueryId })
    return ''
  }
  return [huntQueryId, ...pivotIds].join(',')
}
